import { store } from 'store'
import { updateWsConnection } from 'store/ws/actions'
import { MessageDataType } from './types'
import { onMessageBadges } from './messages/badges'
import { onMessagePong } from './messages/pong'
import { onMessageOrderbook } from './messages/orderbook'
import { onMessageTick } from './messages/tick'
import { onMessageOrder } from './messages/orders'
import { onMessageSpotMatch } from './messages/spotMatched'
import { onMessagePositionChanged } from './messages/positionChanged'
import { onMessageAccountChanged } from './messages/accountChanged'
import { onMessagePrices } from './messages/prices'
import { onMessageNotification } from './messages/notification'
import { onMessageLastBar } from './messages/bar'
import { ZkexConnection } from './connection'

export const zkexConnection = new ZkexConnection()

zkexConnection.onReady((connection) => {
  const connectId = connection.getConnectId()
  store.dispatch(updateWsConnection(connectId))

  connection.onMessage<MessageDataType>((data) => {
    onMessageOrderbook(data)
    onMessageOrder(data)
    onMessagePong(data)
    onMessageTick(data)
    onMessageSpotMatch(data)
    onMessagePositionChanged(data)
    onMessageAccountChanged(data)
    onMessagePrices(data)
    onMessageNotification(data)
    onMessageLastBar(data)
    onMessageBadges(data)
  })

  connection.onClose((event) => {
    store.dispatch(updateWsConnection(0))
  })

  connection.onError((e) => {
    console.error(e)
    store.dispatch(updateWsConnection(0))
  })
})
